import { setCookie, getCookie } from '../utils/cookies';

let abortController;

let cartId = JSON.parse(getCookie('cart-id'));
const cartTotal = document.querySelector('.js-cart-total');

const token = document.querySelector('meta[name="csrf-token"]').content;

const queryStore = async (endpoint, params) => {
  const response = await fetch(`/actions/businesslogic/store/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token,
      'Accept': 'application/json',
    },
    body: JSON.stringify(params),
  })
  .then(res => res.json())
  .then(data => {
    return data;
  });

  if (!response.data) {
    throw new Error(`Error fetching data from ${endpoint}: ${response.errors}`);
  }

  return response;
};

const init = () => {
  const buyBtns = document.querySelectorAll('.js-buy-btn');
  const variantInputs = document.querySelectorAll('.js-variant');
  const selectedVariants = document.querySelectorAll('.js-selected-variant');
  const cartModal = document.querySelector('.js-cart');
  if (!cartModal) return;
  const cartList = cartModal.querySelector('.js-cart-list');
  const cartItemTemplate = cartList.querySelector('template.js-cart-item');
  const checkoutBtn = cartModal.querySelector('.js-cart-checkout');

  const getQtyInputs = () => {
    const qtyInputs = document.querySelectorAll(
      '.js-cart-item-qty input:not(.is-initialized)',
    );
    qtyInputs.forEach(qtyInput => {
      qtyInput.classList.add('is-initialized');
      qtyInput.addEventListener('change', async () => {
        qtyInput.closest('.c-number-input__inner').classList.add('is-loading');
        const { data } = await queryStore('cart-lines-update', {
          cartId,
          lines: [
            {
              id: qtyInput.id,
              quantity: parseInt(qtyInput.value),
            },
          ],
        });

        updateCart(
          data.cartLinesUpdate.cart.lines.edges,
          data.cartLinesUpdate.cart.cost.subtotalAmount,
        );
      });
    });
  };

  const updateCart = (lines, total, openCart = false) => {
    const cartItemsForm = cartModal.querySelector('.js-cart-items-form');
    const linesIds = lines.map(line =>
      line.node.merchandise.product.id.split('/').pop(),
    );

    abortController = new AbortController();
    const { signal } = abortController;

    cartItemsForm.querySelector('input[name="ids"]').value =
      JSON.stringify(linesIds);
    const data = new FormData(cartItemsForm);
    const action = cartItemsForm.getAttribute('action');
    const url = `${action}?${new URLSearchParams(data).toString()}`;

    fetch(url, { signal })
      .then(response => response.json())
      .then(res => {
        const availableIds = lines.map(line => line.node.id);
        const cartQtyTots = document.querySelectorAll('.js-cart-qty');
        const cartQty = lines.reduce((acc, line) => {
          return acc + line.node.quantity;
        }, 0);

        if (!cartQty) {
          cartQtyTots.forEach(cartQtyTot => {
            cartQtyTot.textContent = cartQty ?? '';
          });

          cartList.innerHTML = '';

          cartModal.modal.closeModal();
          cartModal.classList.add('is-empty');
        } else {
          cartModal.classList.remove('is-empty');
        }

        const qtyInputs = document.querySelectorAll('.js-cart-item-qty input');
        qtyInputs.forEach(qtyInput => { 
          if (!availableIds.includes(qtyInput.id)) {
            qtyInput.closest('.c-cart__product').remove();
          }
        });

        lines
          .map(line => line.node)
          .forEach(item => {
            if (![...qtyInputs].map(i => i.id).includes(item.id) && cartItemTemplate) {
              const productId = item.merchandise.product.id.split('/').pop();
              const cartItem = document.importNode(
                cartItemTemplate.content,
                true,
              );

              const product = res[productId];
              const cartItemQuantity = cartItem.querySelector(
                '.js-cart-item-qty input',
              );
              cartItemQuantity.id = item.id;

              const cartItemLink = cartItem.querySelector('.js-cart-item-link');
              cartItemLink.href = product.url;
              cartItemQuantity.value = item.quantity;
              const cartItemTitle = cartItem.querySelector('.js-cart-item-title');
              cartItemTitle.textContent = product.title;
              const cartItemColor = cartItem.querySelector('.js-cart-item-color');
              cartItemColor.textContent = product.variant;
              const cartItemVariant = cartItem.querySelector('.js-cart-item-variant');
              if (product.options.length > 1) {
                cartItemVariant.textContent = item.merchandise.title;
              } else {
                cartItemVariant.remove();
              }
              const cartItemPrice = cartItem.querySelector('.js-cart-item-price');
              const cartItemCompareAtPrice = cartItem.querySelector('.js-cart-item-compare-at-price');
              const cartItemImage = cartItem.querySelector('.js-cart-item-img');
              cartItemImage.src = product.image.url;
              cartItemImage.alt = product.image.alt;
              cartItemPrice.textContent = product.price + '€';
              if (product.compareAtPrice) {
                cartItemCompareAtPrice.textContent = product.compareAtPrice + '€';
              } else {
                cartItemCompareAtPrice.remove();
              }
              cartList.appendChild(cartItem);
            }

            cartTotal.textContent =
              parseFloat(parseFloat(total.amount).toFixed(2)) + '€';

            cartQtyTots.forEach(cartQtyTot => {
              cartQtyTot.textContent = cartQty ?? '';
            });

            qtyInputs.forEach(qtyInput => {
              if (qtyInput.id === item.id) {
                qtyInput.value = item.quantity;
              }
              qtyInput.closest('.c-number-input__inner').classList.remove('is-loading');
            });

            getQtyInputs();

            if (openCart) cartModal.modal.openModal();
          });
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        console.warn(err);
      });
  };

  if (cartId) {
    setTimeout(async () => {
      const { data } = await queryStore('get-cart', {
        cartId,
      });

      checkoutBtn.href = data.cart.checkoutUrl;

      updateCart(data.cart.lines.edges, data.cart.cost.subtotalAmount);
    }, 100);
  }

  buyBtns.forEach(buyBtn => {
    buyBtn.addEventListener('click', async () => {
      const variantId = buyBtn.dataset.variantId;
      const lines = [
        {
          quantity: 1,
          merchandiseId: variantId,
        },
      ];

      if (cartId) {
        const { data } = await queryStore('cart-lines-add', {
          cartId,
          lines,
        });

        updateCart(
          data.cartLinesAdd.cart.lines.edges,
          data.cartLinesAdd.cart.cost.subtotalAmount,
        );
      } else {
        const { data } = await queryStore('cart-create', {
          input: {
            lines,
          },
        });

        setCookie('cart-id', JSON.stringify(data.cartCreate.cart.id), 1);
        cartId = JSON.parse(getCookie('cart-id'));

        checkoutBtn.href = data.cartCreate.cart.checkoutUrl;

        updateCart(
          data.cartCreate.cart.lines.edges,
          data.cartCreate.cart.cost.subtotalAmount,
        );
      }
    });
  });

  variantInputs.forEach(input => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      buyBtns.forEach(buyBtn => {
        buyBtn.dataset.variantId = input.value;
      });
      selectedVariants.forEach(selectedVariant => {
        selectedVariant.textContent = input.nextElementSibling.textContent;
      });
    });
  });
};

const module = () => {
  window.addEventListener('load', init);
};

export default module;
